'use strict';

var log = require('debug')('ipfs:mfs:utils:update-mfs:root');

var waterfall = require('async/waterfall');

var CID = require('cids');

var _require = require('./constants'),
    MFS_ROOT_KEY = _require.MFS_ROOT_KEY;

var updateMfsRoot = function updateMfsRoot(ipfs, buffer, callback) {
  var repo = ipfs._repo;
  var datastore = repo && repo.datastore;

  if (!repo || !datastore) {
    return callback(new Error('Please run jsipfs init first'));
  }

  var cid = new CID(buffer);
  log("New MFS root will be ".concat(cid.toBaseEncodedString()));
  waterfall([function (cb) {
    if (repo.closed) {
      log('Opening datastore');
      return datastore.open(function (error) {
        return cb(error);
      });
    }

    log('Datastore was already open');
    cb();
  }, function (cb) {
    return datastore.put(MFS_ROOT_KEY, cid.buffer, function (error) {
      return cb(error);
    });
  }], function (error) {
    return callback(error, cid);
  });
};

module.exports = updateMfsRoot;